require('../../modules/es7.array.flat-map');
module.exports = require('../../modules/_core').Array.flatMap;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/array/flat-map.js
// module id = 1098
// module chunks = 0